<!--实时电能质量,三相电压和不平衡度-->
<template>
	<div class="realPowerQualityBody">
		<!--日期弹窗-->
		<elRadioTree slot="tree" :dataList='virtualDeviceList' @checkItem="nowVirtualDevice = $event"></elRadioTree>
		<div class="pageBody" slot="body">
			<div class="buttonLine">
				<el-select  v-model="nowApptypeGroups" value-key="id" @change="changeTelescopic" multiple collapse-tags style="margin-left: 20px;" placeholder="请选择">
					<el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item">
					</el-option>
				</el-select>
			</div>
			<!--图表-->
			<vchart style="height: calc(65% - 0.37rem);background-color: white;" ref='vchart'></vchart>
			<!--表格显示数据-->
			<infoList ref="infoList" style="height: 35%;" :columns='columns' :dataList="dataList" :pageLen='dataList.length <6?6:dataList.length' :totalSize="dataList.length" :fillAll="true" :showIndex='false'></infoList>
		</div>
	</div>
</template>
<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	export default {
		components: {
			treeBody,
			iconButton,
			vchart,
			infoList,
			multipleSelection,
			elRadioTree,
		},
		props: {},
		data() {
			return {
				from2name: {},
				nowVirtualDevice: undefined,
				nowApptypeGroups: [],
				nowSeries: [],
				refreshInterval: 2000,
				apptypeGroupsList:[],
				columns: [{
					name: '变量名称',
					key: 'variableName'
				}, {
					name: '实时值',
					key: 'value'
				}],
				options: {
					title: {
						text: "实时电能质量",
						left: 'center',
						textStyle: {
							fontWeight: 800,
							fontSize: 22,
						}
					},
					tooltip: {
						trigger: 'axis',
						confine: true,
						formatter: (params, ticket, callback) => {
							var label = new Date(params[0].data[0]).formatByTime() + "</br>"
							params.forEach(item => {
								var values;
								if(isnull(item.data[1])) {
									values = "无采集数据";
								} else {
									values = cutDigital(item.data[1]);
								}
								label += item.seriesName + " : " + values + "</br>"
							})
							return label;
						},
						axisPointer: {
							animation: false
						}
					},
					xAxis: {
						type: 'time',
						splitLine: {
							show: true
						}
					},
					yAxis: {
						type: 'value',
						max: value => {
							return value.max | 0 + 10
						},
						boundaryGap: [0, '100%'],
						splitLine: {
							show: true
						}
					},
					grid: {
						left: '5%',
						right: '5%',
						bottom: '70'
					},
					legend: {
						data: [],
						type: 'scroll',
						bottom: '20px',
						formatter: function(name) {
							return echarts.format.truncateText(name, 100, '14px Microsoft Yahei', '…');
						},
						tooltip: {
							show: true
						},
						selected: {}
					},
					series: []
				}
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.$refs.vchart.setData(this.options, true)
			addNewTask('refreshRealPowerQuality', 1000, this.refreshInterval, -1, () => {
				this.addData()
			})
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.variableNameList)
			removeTask('refreshRealPowerQuality')
		},
		computed: {
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			variableStore() {
				return this.$store.variableStore
			},
			archivesStore() {
				return this.$store.archivesStore
			},
			deviceStore() {
				return this.$store.deviceStore
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			virtualDeviceList() {
				var appTypeNos = this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
				return [deviceList(this.$store.deviceStore.getters.getReadDeviceTreeWithTypeNos(appTypeNos.join(','), this.nowUnit.id))]
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			variableTree() {
				if(this.nowVirtualDevice == undefined) {
					return []
				}
				return this.$store.variableStore.getters.getVariableTree(this.nowVirtualDevice.no)
			},
			variableNameList() {
				//当前应该显示的变量fromname列表
				var ag = []
				for(var i = 0, len = this.nowApptypeGroups.length; i < len; i++) {
					var item = this.nowApptypeGroups[i]
					if(item.id == -1 || item.id == -2) {
						ag = ag.concat(item.next.map(ni => {
							return ni.id
						}))
					} else {
						ag.push(item.id)
					}
				}
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.no)
				})
				if(isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {
						this.from2name[i.fromName] = i.name
						v2.push(i.fromName) //fromName
					})
				})
				return v2
			},
			apptypeGroups() {
				return this.$store.variableStore.state.powerApptypeGroup
			},
			dataList() {
				//获取值
				var vl = this.realTimeValueStore.getters.getValue(this.variableNameList)
				return this.variableNameList.map((item, index) => {
					var value = this.realTimeValueStore.getters.getText(item, vl[index])
					if(isNaN(parseFloat((value))) || isnull(parseFloat((value)))) {
						value = undefined
					}
					var variableName = this.from2name[item] ? this.from2name[item] : item
					return {
						variableName: variableName.subByFirstChar("."),
						value,
					}
				})

			}
		},
		watch: {
			variableNameList(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
				//重置缓存数据
				var list = []
				var dataList = []
				var now = new Date().getTime()
				for(var i = 0; i < 20; i++) {
					dataList.unshift([now - this.refreshInterval * i, undefined])
				}
				nv.forEach(item => {
					var name = this.from2name[item] ? this.from2name[item] : item
					list.push({
						name: name.subByFirstChar("."),
						fromName: item,
						type: 'line',
						data: dataList.copy()
					})
				})
				this.nowSeries = list
				this.options.series = list
				var selected = {}
				this.options.legend.data =
					nv.map((item, index) => {
						var name = item.substr(item.indexOf('.') + 1)
						if(index > 5) {
							selected[name] = false
						}
						return {
							name: name,
							icon: 'roundRect'
						}
					})
				this.options.legend.selected = selected
				if(this.nowVirtualDevice) {
					this.options.title.text = this.nowVirtualDevice.name + '-实时电能质量'
				}
				this.$refs.vchart.setData(this.options, true)
			},
		},
		methods: {
			changeTelescopic(data){
				console.log(data)
			},
			addData() {
				//获取值
				if(this.$refs.vchart == undefined) {
					removeTask('refreshRealPowerQuality')
					return
				}
				var vl = this.realTimeValueStore.getters.getValue(this.variableNameList)
				var now = new Date().getTime()
				this.nowSeries.forEach((item, index) => {
					item.data.shift()
					var temp = vl[index]
					if(isNaN(parseFloat(temp)) || isnull(parseFloat(temp))) {
						temp = undefined
					}
					item.data.push([now, temp])
				})
				if(this.$refs.vchart != undefined) {
					this.$refs.vchart.setData({
						series: this.nowSeries
					})
				}
			}
		}
	}
</script>

<style scoped>
	.pageBody {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	
	.realPowerQualityBody {
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
	}
</style>